import React from 'react';
import {StyleSheet,View} from 'react-native';
import {Observer} from 'mobx-react-lite';

import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {useStores} from '../../stores/use-stores';
import theme from '../../style/theme';
import Text from '../ui-controls/Text';

export default function CartCountBadge() {
  const {cartStore} = useStores();
  const {isWebDesktopScreen} = useWebScreenDimensions();

  const styles = isWebDesktopScreen ? webDesktopStyles : nativeStyles;

  return (
    <Observer>
      {() => (
        <View
          testID="cart-count-badge"
          style={
            !cartStore.dirtyOrder ? styles.badge : [styles.badge, styles.dirty]
          }>
          <Text
            variant="caption"
            style={
              !cartStore.dirtyOrder
                ? styles.badgeText
                : [styles.badgeText, styles.dirtyText]
            }>
            {cartStore.updatingOrder || cartStore.isLoadingOrder
              ? '..'
              : cartStore.getTotalOrderCount()}
          </Text>
        </View>
      )}
    </Observer>
  );
}

const webDesktopStyles = StyleSheet.create({
  badge: {
    position: 'absolute',
    backgroundColor: theme.colour.general.secondary,
    paddingHorizontal: 6,
    borderRadius: 8,
    right: 16,
    top: 10,
  },
  dirty: {
    backgroundColor: theme.colour.general.secondary,
  },
  badgeText: {
    color: theme.colour.general.primary,
  },
  dirtyText: {
    color: theme.colour.general.highlight,
  },
});

const nativeStyles = StyleSheet.create({
  badge: {
    position: 'absolute',
    backgroundColor: theme.colour.general.primary,
    paddingHorizontal: 6,
    borderRadius: 8,
    right: 8,
    top: 4,
  },
  dirty: {
    backgroundColor: theme.colour.general.secondary,
  },
  badgeText: {
    color: theme.colour.text.tabIcons.cart.priceBadge,
  },
  dirtyText: {
    color: theme.colour.general.primary,
  },
});
